module.exports = __webpack_public_path__ + "img/general-banking.4fb15fa.png";